import { ModalAnswerType, ModalButtons } from "../styles";
import ButtonDefault from "../../../../form/ButtonDefault";

export default function ResolvePendenciaComum({
    profissional,
    pendencia,
    resolvePendencia,
    fechaPendencia,
    setResposta
}: {
    profissional: any;
    pendencia: any;
    resolvePendencia: () => void;
    fechaPendencia: () => void;
    setResposta: (resposta: string) => void;
}) {
    const label = pendencia.tipo === 's_informacao' ? 
    'Escritório' : 
    profissional?.nome.split(' ')[0] + ' ' + profissional?.id_usuario;
    return (
        <ModalAnswerType>
            <div className="title">
                {label} solicitou uma <span>informação</span>:
            </div>

            <div className="request">"{pendencia?.descricao}"</div>
            
            <div className="info-description">Descreva a sua resposta abaixo:</div>

            <div className="text">
                <textarea
                    name="justify"
                    id="1"
                    className="text-area"
                    onChange={(e) => setResposta(e.target.value)}
                />
            </div>

            <ModalButtons>

                <ButtonDefault
                    className="cancel"
                    onClick={() => fechaPendencia()}
                >
                    Voltar
                </ButtonDefault>
                <ButtonDefault
                    className="continue"
                    onClick={() => resolvePendencia()}
                >
                    Resolver
                </ButtonDefault>

            </ModalButtons>

        </ModalAnswerType>
    )
}